export default {
    init() {
        const self = this

        $('.service-link.vertical-arrow').on('click', function() {
            const $parent = $(this).parents('.service-list-item')

            if (!$parent.hasClass('service-open')) {
                self.openItem($parent)
            } else {
                self.closeItem($parent)
            }
        });
    },

    openItem(element) {
        const height = element.find('.content-inner').outerHeight()
        element.find('.collapsible-content').css('height', `${height}px`)
        element.addClass("service-open");
    },

    closeItem(element) {
        element.find('.collapsible-content').css('height', `0px`)
        element.removeClass("service-open");
    }

}